import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { contactAPI } from '../../services/api';

export const fetchContacts = createAsyncThunk('contact/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await contactAPI.getAll(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch contacts');
  }
});

export const updateContact = createAsyncThunk('contact/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await contactAPI.update(id, data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to update contact');
  }
});

export const deleteContact = createAsyncThunk('contact/delete', async (id, { rejectWithValue }) => {
  try {
    await contactAPI.delete(id);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete contact');
  }
});

const contactSlice = createSlice({
  name: 'contact',
  initialState: { contacts: [], loading: false, error: null, pagination: null },
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContacts.pending, (state) => { state.loading = true; })
      .addCase(fetchContacts.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = action.payload.data || [];
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchContacts.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(updateContact.fulfilled, (state, action) => {
        const index = state.contacts.findIndex(c => c.id === action.payload.id);
        if (index !== -1) state.contacts[index] = action.payload;
      })
      .addCase(deleteContact.fulfilled, (state, action) => {
        state.contacts = state.contacts.filter(c => c.id !== action.payload);
      });
  },
});

export const { clearError } = contactSlice.actions;
export default contactSlice.reducer;
